import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Clears click-blocking leftovers (orphaned modal/tour scroll + pointer locks)
// on every route change so no page can be left frozen behind an invisible layer.
export const NavigationSafetyNet = () => {
  const location = useLocation();

  useEffect(() => {
    const t = setTimeout(() => {
      const hasOpenDialog = document.querySelector('[data-state="open"][role="dialog"], [data-state="open"][role="alertdialog"]');
      if (!hasOpenDialog) {
        if (document.body.style.pointerEvents === 'none') document.body.style.pointerEvents = '';
        if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
      }
    }, 300);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return null;
};

export default NavigationSafetyNet;
